const path = require('path')

module.exports = function (paths) {
    const FURTHER_REF = paths.FURTHER_REF
    return {
        test: /\.(htm|html|xhtml|hbs|handlebars|ejs|mustache|nunjucks|tpl)$/,
        loader: FURTHER_REF + 'htmllint-loader',
        query: {
            config: path.resolve(FURTHER_REF, '../', '.htmllintrc'),
            failOnError: true,
            failOnWarning: true
        },
        exclude: /node_modules/
    }
}


// WEBPACK FOOTER //
// ./src/technologies/markups.js